import { render, staticRenderFns } from "./EditDrug.vue?vue&type=template&id=9c5ee4ce&scoped=true&lang=pug&"
import script from "./EditDrug.vue?vue&type=script&lang=ts&"
export * from "./EditDrug.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5ee4ce",
  null
  
)

export default component.exports